<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
        <b-card
            title="لیست تماس ها"
        >
            <b-row v-if="call !== null">
                  <b-col>
                    <b-link
                        :to="{ name: 'userDetail', params: { id: call.User.Id }}"
                        class="font-weight-bold"
                    >
                      <span>{{$t('common.fullName')}}</span>
                      :
                      <span>{{call.User.Name}}-{{call.User.Family}}</span>
                    </b-link>
                  </b-col>
                  <b-col>
                    <span>{{$t('login.mobile')}}</span>
                    :
                    <span>{{call.User.Mobile}}</span>
                  </b-col>
                  <b-col >
                    <b-button :loading="loading" class="float-right" @click="openCoponModal">ارسال کد تخفیف</b-button>
                  </b-col>
            </b-row>
        </b-card>
    <b-card>
      <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          class="float-right"
          @click="back"
      >
        بازگشت
      </b-button>
      <b-button
          variant="primary"
          class="mb-1 mr-auto ml-1"
          @click="showModal = true"
      >
        {{ $t('common.new') }}
      </b-button>
      <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          :no-local-sorting="true"
      >
        <template #cell(Expert)="data">
            <span class="text-nowrap">
              {{ data.item.Expert.Name }} {{ data.item.Expert.Family }}
            </span>
        </template>
      </b-table>
    </b-card>

    <b-modal
        v-model="showModal"
        title="افزودن تماس جدید"
        cancel-variant="outline-secondary"
        :no-close-on-backdrop="true"
        hide-footer
        centered
        size="md"
    >
      <b-overlay
          :show="loading"
          rounded="sm"
      >
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="12">
              <b-form-group
                  label="توضیحات"
                  label-for="Description"
              >
                <div class="form-label-group">
                  <b-form-textarea
                      id="Description"
                      v-model="form.Description"
                      name="Description"
                      autocomplete="off"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="نتیجه تماس">
                <v-select
                    v-model="form.CallResult"
                    dir="rtl"
                    :reduce="x => x.value"
                    :clearable="true"
                    label="text"
                    :options="enums('callResultTypes')"
                />
              </b-form-group>
              <b-form-group>
                <b-form-checkbox
                    v-model="form.CanDiet"
                    class="custom-control-success"
                >
                   بتواند رژیم بگیرد
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-end mt-3">
            <b-button
                variant="primary"
                class="mr-1"
                @click="save"
            >
              <feather-icon
                  icon="fa fa-loading"
                  class="mr-50"
              />
              ذخیره
            </b-button>
            <b-button
                variant="outline-secondary"
                @click="showModal = false"
            >
              انصراف
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </b-modal>
    <b-modal
        v-model="showModalCopon"
        title="ارسال کپن"
        cancel-variant="outline-secondary"
        :no-close-on-backdrop="true"
        hide-footer
        centered
        size="md"
    >
      <b-overlay
          :show="loading"
          rounded="sm"
      >
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="12">
              <b-form-group
                  label="نام"
                  label-for="Description"
              >
                <div class="form-label-group">
                  <b-form-input
                      v-model="formCopon.Name"
                      name="نام"
                      autocomplete="off"
                  />
                </div>
              </b-form-group>
               <b-form-group
                  label="موبایل"
                  label-for="Description"
              >
                <div class="form-label-group">
                  <b-form-input
                      v-model="formCopon.Mobile"
                      name="موبایل"
                      autocomplete="off"
                  />
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-end mt-3">
            <b-button
                variant="primary"
                class="mr-1"
                @click="sendCopon"
            >
              <feather-icon
                  icon="fa fa-loading"
                  class="mr-50"
              />
              ذخیره
            </b-button>
            <b-button
                variant="outline-secondary"
                @click="showModal = false"
            >
              انصراف
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </b-modal>

  </b-overlay>

</template>

<script>

export default {
  name: 'FaqDetails',
  data() {
    return {
      showModal: false,
      showModalCopon: false,
      form: {
        CanDiet:false
      },
      formCopon: {
        Name:null,
        Mobile: null,
        UserId:null
      },
      call:null,
      loading: false,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Description',
          label: this.$t('common.description'),
        },
        {
          key: 'Expert',
          label: this.$t('common.Expert'),
        },

        {
          key: 'CallResultText',
          label:'وضعیت تماس',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$route.params.id) {
      this.form.UserCallRequestId = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.callCenterList.add
      this.loading = true
      this.$http.post(
          url, this.form,
      )
          .then(() => {
            this.showModal = false
            this.get()
          }).finally(() => {
        this.loading = false
      })
    },
    sendCopon() {
      let url = this.$api.callCenterList.sendCopon
      this.loading = true
      this.$http.post(
          url, this.formCopon,
      )
          .then(() => {
            this.showModalCopon = false
          }).finally(() => {
        this.loading = false
      })
    },

    get() {
      this.loading = true
      this.$http.get(this.$api.callCenterList.get, { params: {id:this.$route.params.id} },)
          .then(res => {
            this.loading = false
            this.call = res.data
            this.items = res.data.CallHistory
          })
    },
    openCoponModal (){
      this.formCopon.Name = this.call.User.Name + ' ' + this.call.User.Family
      this.formCopon.Mobile = this.call.User.Mobile
      this.formCopon.UserId = this.call.User.Id
      this.showModalCopon = true
    }
  },
}
</script>
